import { useState } from 'react'
import { useAccessZonesListQuery } from 'shared/data'
import {
  getPageOnBySource,
  PaginationSource,
  usePagination,
  withNameFilter,
} from './use-pagination'

interface UseAccessZonesListOptions {
  source: PaginationSource
  defaultPageSize?: number
  debounce?: number
}

export const useAccessZonesList = ({
  source,
  defaultPageSize = 20,
  debounce = 1000,
}: UseAccessZonesListOptions) => {
  const [initialPageSize] = useState(
    () => getPageOnBySource(source) ?? defaultPageSize
  )

  const { data, loading, refetch } = useAccessZonesListQuery({
    first: initialPageSize,
  })

  const connection = data?.viewer.accessZones

  const { pagination, search, isSearchPending } = usePagination({
    initPageSize: initialPageSize,
    pageInfo: connection?.pageInfo,
    totalCount: connection?.totalCount ?? 0,
    loading,
    source,
    debounce,
    refetch: variables => refetch(withNameFilter(variables)),
  })

  return {
    zones: connection?.nodes ?? [],
    pagination,
    search,
    isLoading: loading || isSearchPending,
  }
}
